export default "__VITE_ASSET__803eb591__"